import React, { useEffect, useState } from 'react'
//import { useParams } from 'react-router-dom'
import QRCode from "react-qr-code";
import useMountEffect from '../utils/hooks/useMountEffect'
import { createGlobalStyle } from 'styled-components'

const PrintStyles = createGlobalStyle`
  @media print {
    body * { visibility: hidden; }
    #printableArea, #printableArea * { visibility: visible; }
    #printableArea { position: absolute; left: 0; top: 0; }
  }
  @media screen {
    body { background: white; }
  }
`

const InventoryActionPagePrint = () => {
    //const { printcode } = useParams()
    const [printCodes, setPrintCodes] = useState([])
    const [print, setPrint] = useState(false)
    useEffect(() => {
        setTimeout(() => {
            setPrint(true)
        }, 2000);
    }, [])

    useEffect(() => {
        if (print) {
            window.addEventListener('afterprint', () => window.close(), { once: true })
            window.print()
        }
    }, [print])

    const checkSessionStorage = async () => {
        if (sessionStorage.getItem('printBarcodeNumbers')) {
            let printBarcodeNumbers = JSON.parse(
                sessionStorage.getItem('printBarcodeNumbers')
            )
            sessionStorage.removeItem('printBarcodeNumbers')
            if (printBarcodeNumbers) {
                setPrintCodes(printBarcodeNumbers)
            }
        }
    }
    useMountEffect(() => {
        checkSessionStorage()
    })

    return (
        <>
            <PrintStyles />
            <div id="printableArea">
                <div className="mb-5" />
                {printCodes.map((code, index) =>
                    <React.Fragment key={index} >
                        <div>
                            <QRCode value={code} size={128} />
                        </div>
                        <div className="mb-5" />
                    </React.Fragment >
                )}
            </div>
        </>
    )
}

export default InventoryActionPagePrint
